import BonusQuestionSection from "@/components/pages/CartoonDetailPage/BonusQuestionSection/BonusQuestionSection"
import BonusQuestionSectionContext from "@/components/pages/CartoonDetailPage/BonusQuestionSection/BonusQuestionSectionContext"
import { useState } from "react"

interface BonusQuestionSectionProps {
  bonusQuestionId: string
  comicsBackgroundImageUrl: string
  comicsName: string
  comicsSlug: string
}

const BonusQuestionSectionWrapper = ({
  bonusQuestionId,
  comicsBackgroundImageUrl,
  comicsName,
  comicsSlug,
}: BonusQuestionSectionProps) => {
  const [coins, setCoins] = useState<number>(0)
  const [answerState, setAnswerState] = useState<"success" | "failure" | "">("")
  return (
    <BonusQuestionSectionContext.Provider value={{ coins, setCoins, answerState, setAnswerState }}>
      <BonusQuestionSection
        bonusQuestionId={bonusQuestionId}
        comicsBackgroundImageUrl={comicsBackgroundImageUrl}
        comicsName={comicsName}
        comicsSlug={comicsSlug}
      />
    </BonusQuestionSectionContext.Provider>
  )
}

export default BonusQuestionSectionWrapper
